/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Loading, Tab, Tabs,FormGroup,ComboBox,Checkbox, TabsSkeleton } from 'carbon-components-react';
import { Information16, CheckmarkOutline16, Send16, Error16 } from '@carbon/icons-react';
import { v4 as uuid } from 'uuid';
import PageBreadCrumb from '../../../helpers/PageBreadCrumb';
import { me, api, drill } from '../../../helpers/api/api';
import {
  getError,
  getSuccess,
  apioperation,
  entitiesLabels,
  STATUS,
} from '../../../helpers/Constants';
import { showNotification } from '../../../helpers/notification/BaseNotification';
import { IsEnabled, IsEditable, CanExecuteAction } from '../../../helpers/authorization/Policies';
import { WFActionModal } from '../../common/WFActionModal';
import { HistoryTable } from '../../../helpers/HistoryTable';
import { AppContext } from '../../../helpers/context/AppContext';
import { Online } from '../../common/OnLineOffLine';

import { DrillReportInformation } from './reportDetails/DrillReportInformation';
import { DrillReportDetail } from './reportDetails/DrillReportDetail';
import DrillPersonnel from './reportDetails/DrillPersonnel';
import { DrillReportSummary } from './reportDetails/DrillReportSummary';
import DrillNotificationForm from './reportDetails/DrillNotificationForm';
import DrillReportSignedAttachment from './reportDetails/DrillReportSignedAttachment';
import DrillRepository from '../../../helpers/api/DrillRepository';
import  {WarningModal}  from '../../common/WarningModal';//RITM1037347

export class DrillReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idReason: null, //RITM1037347
      isReasonModalOpen: false,//RITM1037347
      reason: null,//RITM1037347     
      xReasons: [],//RITM1037347
      isWarningReOpenModalOpen: false,//RITM1037347   
      isReopenCar: false,  //RITM1230561
      isLoadingDrillReport: true,
      downloading: null,
      tabsLoading: true,
      isSubmitted: false,
      id: this.props.match.params?.id || null,
      drillReport: {},
      lightCondition: [],
      seaCondition: [],
      weatherCondition: [],
      emergencylevel: [],
      unitsInvolved: [],
      // /Status Action
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      // approvalStartDate: null,
      // approvalEndDate: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      // idToDelete: null,
      // selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      validationDeliveryDate: false,
      // HT
      isHistoryModalOpen: false,
      editingDisabled: this.state?.drillReport
        ? !IsEditable(
            'Emergency Drill',
            'Reporting',
            this.context.user,
            this.state.drillReport.status.id,
            'All',
            this.state.drillReport
          )
        : false,
    };
    this.renderLoadingModal = this.renderLoadingModal.bind(this);

    // notification
    this.updateNotificationData = this.updateNotificationData.bind(this);
    this.sendNotificationData = this.sendNotificationData.bind(this);

    // attacchment
    // this.onUpload = this.onUpload.bind(this);
    this.onUploadAttachment = this.onUploadAttachment.bind(this);
    this.onUploadSignedAttachment = this.onUploadSignedAttachment.bind(this);
    this.downloadAttachment = this.downloadAttachment.bind(this);
    this.downloadSignedAttachment = this.downloadSignedAttachment.bind(this);
    // this.onDownload = this.onDownload.bind(this);
    this.deleteAttachment = this.deleteAttachment.bind(this);
    this.deleteSignedAttachment = this.deleteSignedAttachment.bind(this);
    // this.onDelete = this.onDelete(this);
    this.downloadAnswerAttachment = this.downloadAnswerAttachment.bind(this);
    this.uploadAnswerAttachment = this.uploadAnswerAttachment.bind(this);
    this.deleteAnswerAttachment = this.deleteAnswerAttachment.bind(this);
    this.requirementDelete = this.requirementDelete.bind(this);
    this.updateAnswers = this.updateAnswers.bind(this);
    this.updateMainInformation = this.updateMainInformation.bind(this);
  }

  async componentDidMount() { //RITM1290744
    this.setState({ tabsLoading: true });
    await this.getDrillReport(); //RITM1290744
    await this.getWeatherConditions(); //RITM1290744
    
  }
//RITM1037347
getReasons() {  
  api
      .getAll(`/drill/reasons/${this.state.drillReport.referenceYear}`)
      .then((response) => {this.setState({
              xReasons: response.data,
          });
      })
      .catch((error) => {
          showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.GET));
      });
} 
     
            //RITM1037347 end

  showButtonHistory = () => (
    <Button
      className="action-button-modal"
      kind="secondary"
      renderIcon={Information16}
      onClick={() => this.openModalHistory()}
    >
      History
    </Button>
  );

  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };

  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };

  getDrillReport = async () => {
    await drill
      .getReport(this.state.id)
      .then((response) => {
        if (response.status === 200) {
          const { data } = response;

          this.setState({
            drillReport: data,
            // notificationForm: data.drillNotificationForm,
            // activities: data.drillNotificationForm?.activities,
            tabsLoading: false,
            editingDisabled: !IsEditable(
              'Emergency Drill',
              'Reporting',
              this.context.user,
              data?.status?.id,
              'All',
              data
            ),
          });
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.DRILLREPORT, apioperation.GET));
      })
      .finally(() => {
        this.setState({ isLoadingDrillReport: false });
        this.getReasons();
      });
  }

  getWeatherConditions = async () => { //RITM1290744
    this.setState({ tabsLoading: true });
    // endpoint
    api
      .getAll('/drill/lightCondition')
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            lightCondition: response.data,
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`,
            getError('Unsuccessfully get', entitiesLabels.LIGHTCONDITIONS, apioperation.GET)
          );
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.LIGHTCONDITIONS, apioperation.GET));
      })
      .finally(() => {});
    api
      .getAll('/drill/seaCondition')
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            seaCondition: response.data,
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`,
            getError('Unsuccessfully get', entitiesLabels.SEACONDITIONS, apioperation.GET)
          );
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.SEACONDITIONS, apioperation.GET));
      })
      .finally(() => {});
    api
      .getAll('/drill/weatherCondition')
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            weatherCondition: response.data,
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`,
            getError('Unsuccessfully get', entitiesLabels.WEATHERCONDITIONS, apioperation.GET)
          );
        }
      })
      .finally(() => {});
    await api  //RITM1290744
      .getAll('drill/emergencylevel')
      .then((response) => {
        if (response.status === 200) {
          const data = (response.data || []).filter((el) => el.inUse || this.state.drillReport?.idEmergencyLevel == el.id); //RITM1290744
          this.setState({
            //emergencylevel: response.data,
            emergencylevel: data, //RITM1290744
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`,
            getError('Unsuccessfully get', entitiesLabels.EMERGENCYDRILL, apioperation.GET)
          );
        }
      })
      .finally(() => {});
    api
      .getAll('drill/unitsInvolved')
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            unitsInvolved: response.data,
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`,
            getError('Unsuccessfully get', entitiesLabels.EMERGENCYDRILL, apioperation.GET)
          );
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WEATHERCONDITIONS, apioperation.GET));
      })
      .finally(() => {
        this.setState({ tabsLoading: false });
      });
  };
  //RITM1037347
  showButtonReopen = () => (
    <Button
     className="action-button-modal"
     kind="secondary"
     //renderIcon={Edit16}
       onClick={this.toggleReasonModal}
     > 
       Reopen 
     </Button>
   );
   toggleReasonModal = () => {
     this.setState((oldState) => ({
         reason: null,
         isReopenCar:false,//RITM1230561
         isReasonModalOpen: !oldState.isReasonModalOpen,
     }));
 };
 divModalReopenReason() {
   return (<div className="bx--modal bx--modal-tall is-visible">
       <div className="bx--modal-container modal-overflow-visible">
           <div className="bx--modal-header">
               <h3 className="bx--modal-header__heading"> REASON TO REOPEN </h3>{' '}
           </div>
           <br></br>
           <div className="bx--row">
               <div className="bx--col-lg-12 bx--col-md-6">
                   <FormGroup
                       legendText="REASON TO REOPEN the EDRILL REPORT* " >
                       <ComboBox
                           id="idReason"
                           placeholder="Select"
                           name="Reason"
                           alt="Reason"
                           onChange={(el) =>
                               this.setState({
                                   reason: el.selectedItem?.id
                               })
                           }                               
                           itemToString={(item) => (item ? item.name : '')}
                           initialSelectedItem={"Select"}                                
                           items={this.state.xReasons}
                       />
                   </FormGroup>
               </div>
 
           </div>
           {/* RITM1230561 */}
            <div className="bx--col-md-4 bx--col-lg-4">
              <FormGroup legendText="Do you want to reopen also the follwing closed CAR/CA (if any)? ">
                <Checkbox
                  id="isReopenCar"
                  labelText=""
                  checked={this.state.isReopenCar}
                  onChange={this.onchkReopenedCarChange}
                />
              </FormGroup>
             </div>
           <div className="searchFormFooter mt-20">
               <Button
                   className="button--max-width"
                   kind="secondary"
                   onClick={this.toggleReasonModal}
               >
                   Cancel
               </Button>
               <Button
                   className="button--max-width"
                   kind="primary"
                   onClick={this.toggleWarningReOpenModal}
                   disabled={this.state.reason == 'Select' ||this.state.reason == null}
               >
                   Save
               </Button>
           </div>
       </div>
   </div>
   );
 }
 toggleWarningReOpenModal = () => {
   this.setState((prevState) => ({
       isWarningReOpenModalOpen: !prevState.isWarningReOpenModalOpen,
   }));        
 };
 handleConfirmReOpenSubmit = () => {
   this.setState(
       {
           isWarningReOpenModalOpen: false,
       },
       this.toggleReasonModal(),
       this.ReopenEMDrillReportData()
       // () => this.submitReport(true)
   );
 };
 ReopenEMDrillReportData = () => {  
   api   
       .put(`/drill/reopenreport/${this.state.drillReport.id}/${this.state.reason}/${this.state.isReopenCar}`)
       .then((response) => {
           if (response.status === 200) {
               this.setState({
                   isWarningReOpenModalOpen: false,
               });
               showNotification.success(
                   `${entitiesLabels.SUCCESS}`,
                   getSuccess(entitiesLabels.REPORT, apioperation.PUT)
               );
               this.getDrillReport();
           } else {
               showNotification.error();
           }
       })
       .catch((error) => {
           showNotification.error(
               `${entitiesLabels.ERROR}`,
               getError(error, entitiesLabels.REPORT, apioperation.PUT)
           );     
      
        })
        .finally(()=>{})
 };
// RITM1230561
 onchkReopenedCarChange = (e) => {
  const val = e;
  this.setState({   
    isReopenCar: val,
  });
};
  //RITM1037347 end
 
 
  //* *************WF ACTION************ */
  getStatusActions = (user) => {
    if (!this.IsRowSelectable()) return null;

    return (
      <Online>
        <>
          {CanExecuteAction(
            'Emergency Drill',
            'Reporting',
            user,
            this.state.drillReport.idStatus,
            'Submit',
            this.state.drillReport
          ) ? (
            <Button
              renderIcon={Send16}
              onClick={() => {
                if (this.state.drillReport.deliveryDate !== '0001-01-01T00:00:00Z') {
                  this.batchActionClick(
                    'submitreport',
                    'Submit',
                    'Data Approver',
                    true,
                    false
                  );
                } else {
                  this.validation();
                  showNotification.warning(`${entitiesLabels.WARNING}`,
                    ` ${entitiesLabels.NOTIFICATION} required fields are missing  `
                  );

                  this.forceUpdate();
                }
              }}
            >
              Submit Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Emergency Drill',
            'Reporting',
            user,
            this.state.drillReport.idStatus,
            'Approve',
            this.state.drillReport
          ) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() =>
                this.batchActionClick(
                  'approvereport',
                  'Approve',
                    null, /* RUOLI_APPROVATIVI_DEV_255_RITM0565449 */
                    false, /* RUOLI_APPROVATIVI_DEV_255_RITM0565449 */
                  false
                )
              }
            >
              Approve Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Emergency Drill',
            'Reporting',
            user,
            this.state.drillReport.idStatus,
            'Consolidate',
            this.state.drillReport
          ) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() =>
                this.batchActionClick('consolidatereport', 'Consolidate', null, false, false)
              }
            >
              Consolidate Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Emergency Drill',
            'Reporting',
            user,
            this.state.drillReport.idStatus,
            'Reject',
            this.state.drillReport
          ) ? (
            <Button
              renderIcon={Error16}
              onClick={() =>
                this.batchActionClick('rejectreport', 'Reject', null, false, true)
              }
            >
              Reject Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Emergency Drill',
            'Reporting',
            user,
            this.state.drillReport.idStatus,
            'RejectConsolidate',
            this.state.drillReport
          ) ? (
            <Button
              renderIcon={Error16}
              onClick={() =>
                this.batchActionClick('rejectconsolidatereport', 'Reject', null, false, true)
              }
            >
              Reject Report
            </Button>
          ) : null}
        </>
      </Online>
    );
  };

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired
  ) {
    const idWorksite = this.state.drillReport?.workSite?.id; //RITM1064131
		const idDivision = this.state.drillReport?.division?.id; //RITM1064131

    this.setState({
      approvalModalAction: actionName,
      isApprovalModalOpen: true,
      isLoadingApproverOptions: true,
      withApprover,
      // selectedData: selectedRows,
      approverRole,
      approvalEndpoint: actionKey,
      approvalNotesRequired,
    });

    if (withApprover) this.getUsersInRole(approverRole, 'Emergency Drill', idWorksite, idDivision); //RITM1064131
  }

  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    const apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: [this.state.id],
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(`/drill/${apiEndpoint}`, data, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            tabsLoading: true,
          });
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.DRILLREPORT, apioperation.PUT));
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {
        this.setState(
          {
            tabsLoading: false,
          }
        );
        this.getDrillReport();
      });
  };

  getUsersInRole = (role, appModule, idWorksite, idDivision) => { //RITM1064131
    me.getWithParam('getuserbyroleandmodule', { //RITM1064131
      params: { Role: role, appModule: appModule, idWorksites: idWorksite, IdDivision: idDivision, includeAdmins: true }, //RITM1064131
    })
      .then((response) => {
        this.setState({
          approvers: response.data,
          isLoadingApproverOptions: false,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.ROLE, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingApproverOptions: false,
        });
      });
  };

  IsRowSelectable() {
    const { drillReport } = this.state;
    if (drillReport == null || drillReport.idStatus === STATUS.Consolidated) {
      return false;
    }
    return true;
  }

  updateMainInformation = async () => {
    try {
      this.setState({ isSubmitted: true, editingDisabled: true });

      await api.put('/drill/maininformation', this.state.drillReport);
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
    } finally {
      this.setState({ isSubmitted: false, editingDisabled: false });
    }
  };

  // ***************** NOTIFICATION FORM ***************** START
  updateNotificationData = async (item) => {
    if (this.state.drillReport.deliveryDate === null || this.state.drillReport.deliveryDate === '0001-01-01T00:00:00Z' || !this.state.drillReport.drillReportProjects[0]) {
      showNotification.warning(`${entitiesLabels.WARNING}`,
                               `${entitiesLabels.EMERGENCYDRILL} required fields are missing : 
                               ${(this.state.drillReport.deliveryDate === null || this.state.drillReport.deliveryDate === '0001-01-01T00:00:00Z') ? 'Date of DRILL Execution* is missing. ' : ''} 
                               ${(!this.state.drillReport.drillReportProjects[0]) ? 'Project field is missing.' : ''} `
      );
    } else {
      try {
        await this.updateMainInformation();
        this.setState((prevState) => ({
            isSubmitted: true,
            drillReport: {
              ...prevState.drillReport,
              drillNotificationForm: item,
            },
          }));

        await api.put('/drill/report/notification', item);

        const { drillReport } = this.state;
        drillReport.drillNotificationForm = item;
        DrillRepository.updateCachedDrill(drillReport);
        this.setState({ validationDeliveryDate: false });
        // this.repository.updateCachedDrill(drillReport);
        showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.NOTIFICATION, apioperation.PUT));
      } catch (error) {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(entitiesLabels.NOTIFICATION, apioperation.PUT));
      } finally {
        this.setState({ isSubmitted: false });
      }
    }
  };

  validation() {
    this.setState({ validationDeliveryDate: true });
  }

  sendNotificationData = async (notificationItem) => {
    if (this.state.drillReport.deliveryDate === null || this.state.drillReport.deliveryDate === '0001-01-01T00:00:00Z' || !this.state.drillReport.drillReportProjects[0]) {
      showNotification.warning(`${entitiesLabels.WARNING}`,
                               `${entitiesLabels.EMERGENCYDRILL} required fields are missing : 
                               ${(this.state.drillReport.deliveryDate === null || this.state.drillReport.deliveryDate === '0001-01-01T00:00:00Z') ? 'Date of DRILL Execution* is missing, \r' : ''} 
                               ${(!this.state.drillReport.drillReportProjects[0]) ? 'Project field is missing' : ''} `
      );
    } else {
      await this.updateMainInformation();
      const item = notificationItem;
      item.sendedOn = new Date();
      item.sendedBy = this.context.user.email;
      try {
        this.setState((prevState) => ({
            isSubmitted: true,
            drillReport: {
              ...prevState.drillReport,
              drillNotificationForm: item,
            },
        }));
        await api.put('/drill/report/notification/send', item);

        const { drillReport } = this.state;
        drillReport.drillNotificationForm = item;
        DrillRepository.updateCachedDrill(drillReport);
        // this.repository.updateCachedDrill(drillReport);
        showNotification.success(`${entitiesLabels.SUCCESS}`, `${entitiesLabels.EMERGENCYDRILL} notification sent successfully`);
      } catch (error) {
        item.sendedOn = null;
        item.sendedBy = null;
        showNotification.error(`${entitiesLabels.ERROR}`, 'Error occurred, Notification not sent successfully');
      } finally {
        this.setState({ isSubmitted: false });
      }
    }
  };
  // ***************** NOTIFICATION FORM ***************** END

  // ***************** PERSONNEL ***************** START
  updatePersonnel = async (reportEdited) => {
    try {
      this.setState((prevState) => ({
        isSubmitted: true,
        drillReport: {
          ...prevState.drillReport,
          people: reportEdited?.people || [],
        },
      }));
      await api.put('/drill/report/personnel', reportEdited);
      const { drillReport } = this.state;
      drillReport.people = reportEdited?.people || [];
      DrillRepository.updateCachedDrill(drillReport);
      // this.repository.updateCachedAudit(this.state.drillReport);
      showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
    } finally {
      this.setState({ isSubmitted: false });
    }
  };
  // ***************** PERSONNEL ***************** END

  // ***************** REPORT DETAIL FORM ***************** START
  updateReportDetail = async (newDrillReportDetails) => {
    try {
      this.setState({
        isSubmitted: true,
      });
      await api.put('/drill/report/reportDetail', newDrillReportDetails);
      const { drillReport } = this.state;
      drillReport.timelines = newDrillReportDetails?.timelines || [];

      DrillRepository.updateCachedDrill(drillReport);
      // this.repository.updateCachedDrill(this.state.drill);
      showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
    } finally {
      this.setState({ isSubmitted: false });
    }
  };

  // ....=> ************ ATTACHMENT ************ START
  downloadAttachment = async (id) => this.onDownload(id, false)

  downloadSignedAttachment = async (id) => this.onDownload(id, true)

  onDownload = async (id, signedAttachment) => {
    const index = (signedAttachment ?
      this.state.drillReport.signedAttachments.findIndex((a) => a.idAttachment === id) :
      this.state.drillReport.attachments.findIndex((a) => a.idAttachment === id));
    try {
      this.setState({ downloading: id });
      let file = null;
      let name = null;
      if (signedAttachment) {
        file = await api.getBlob(
          `/drill/report/${this.state.drillReport.id}/signedattachment/${encodeURIComponent(this.state.drillReport.signedAttachments[index].attachment.fileIdentifier)}` //RITM1094125
        ).data;
        name = this.state.drillReport.signedAttachments[index].attachment.name;
      } else {
        file = await api.getBlob(
          `/drill/report/${this.state.drillReport.id}/attachment/${encodeURIComponent(this.state.drillReport.attachments[index].attachment.fileIdentifier)}` //RITM1094125
        ).data;
        name = this.state.drillReport.attachments[index].attachment.name;
      }
      return this.downloadFile(file, name);
    } catch (error) {
      return showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.FileUpload, apioperation.GET));
    } finally {
      this.setState({ downloading: null });
    }
  }

  deleteAttachment = async (id) => this.onDelete(id, false)

  deleteSignedAttachment = async (id) => this.onDelete(id, true)

  onDelete = async (id, signedAttachment) => {
    const index = (signedAttachment ? 
      this.state.drillReport?.signedAttachments.findIndex((a) => a.idAttachment === id) :
      this.state.drillReport?.attachments.findIndex((a) => a.idAttachment === id));
    try {
      this.setState({ isSubmitted: true });
      if (signedAttachment) {
        await api.deleteData(
          `/drill/report/${this.state.drillReport.id}/signedattachment/${encodeURIComponent(this.state.drillReport.signedAttachments[index].attachment.fileIdentifier)}` //RITM1094125
        );
      } else {
        await api.deleteData(
          `/drill/report/${this.state.drillReport.id}/attachment/${encodeURIComponent(this.state.drillReport.attachments[index].attachment.fileIdentifier)}` //RITM1094125
        );
      }
      return this.setState((prevState) => {
        const drillReport = { ...prevState.drillReport };
        if (signedAttachment) {
          drillReport.signedAttachments = prevState.drillReport.signedAttachments.filter(
            (a) => a.idAttachment !== prevState.drillReport.signedAttachments[index].idAttachment
          );
        } else {
          drillReport.attachments = prevState.drillReport.attachments.filter(
            (a) => a.idAttachment !== prevState.drillReport.attachments[index].idAttachment
          );
        }
        return { drillReport };
      });
    } catch (error) {
      return showNotification.error(`${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.FileUpload, apioperation.DELETE)
      );
    } finally {
      this.setState({ isSubmitted: false });
    }
  }

  async onUploadAttachment(fileIdentifier, fileName, fileType, size) {
    this.onUpload(fileIdentifier, fileName, fileType, size, false);
  }

  async onUploadSignedAttachment(fileIdentifier, fileName, fileType, size) {
    this.onUpload(fileIdentifier, fileName, fileType, size, true);
  }

  async onUpload(fileIdentifier, fileName, fileType, size, signedAttachement) {
    const newAttach = {
      id: uuid(),
      fileIdentifier: fileIdentifier.blobName,
      name: fileName,
      contentType: fileType,
      size,
    };
    try {
      this.setState({ isSubmitted: true });
      if (signedAttachement) {
        await api.post(`/drill/report/${this.state.drillReport.id}/signedattachment`, newAttach);
      } else {
        await api.post(`/drill/report/${this.state.drillReport.id}/attachment`, newAttach);
      }
      return this.setState(async (prevState) => { //RITM0995432
        const drillReport = { ...prevState.drillReport };
        if (signedAttachement) {
          drillReport.signedAttachments.push({
            idAttachment: newAttach.id,
            idDrillReport: drillReport.id,
            attachment: newAttach,
          });
        } else {
          drillReport.attachments.push({
            idAttachment: newAttach.id,
            idDrillReport: drillReport.id,
            attachment: newAttach,
          });
        }
        await DrillRepository.updateCachedDrill(drillReport); //RITM0995432
        return { drillReport };
      });
    } catch (error) {
      return showNotification.error(`${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.EMERGENCYDRILL, apioperation.POST)
      );
    } finally {
      this.setState({ isSubmitted: false });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  downloadFile(blob, fileName) {
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
  // ....=> ************ ATTACHMENT ************ END

  // ***************** REPORT DETAIL FORM ***************** END

  // ***************** REPORT SUMMARY ***************** START
  async updateAnswers(drillReport) {
    try {
      this.setState({ isSubmitted: true });
      await api.put('/drill/report/checklist', drillReport);
      DrillRepository.updateCachedDrill(drillReport);
      // this.repository.updateCachedAudit(this.state.inspectionModel);               TODO
      showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
      this.setState({ isSubmitted: false });
    } catch (error) {
      showNotification.error(error.response.statusText, error.response.data);
      this.setState({ isSubmitted: false });
    }
  }

  async deleteAnswerAttachment(Id, idAnswerAttachment) {
    const answer = this.state.drillReport.drillCheckListRequirementAnswers.find(
      (item) => item.attachments.count !== 0 && item.id === idAnswerAttachment
    );
    const selectedItem = answer.attachments.find((item) => item.id === Id);
    try {
      this.setState({ isSubmitted: true });
      const { fileIdentifier } = selectedItem.attachment;

      await drill.deleteAttach(
        `/drill/report/${this.state.drillReport.id}/answer/${idAnswerAttachment}/attachment/${encodeURIComponent(fileIdentifier)} ` //RITM1094125
      );
      const index = answer.attachments.indexOf(selectedItem);
      if (index > -1) {
        answer.attachments.splice(index, 1);
      }
      return `${entitiesLabels.SUCCESS}`;
    } catch (error) {
      return showNotification.error(`${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.EMERGENCYDRILL, apioperation.POST)
      );
    } finally {
      this.setState({ isSubmitted: false });
    }
  }

  downloadAnswerAttachment = async (id, idAnswerAttachment) => {
    const answer = this.state.drillReport.drillCheckListRequirementAnswers.find(
      (item) => item.attachments.count !== 0 && item.id === idAnswerAttachment
    );
    const index = answer.attachments.findIndex((a) => a.id === id);
    let file;
    try {
      this.setState({ downloading: id });
      const fileA = answer.attachments[index].attachment;
      file = (
        await api.getAll(
          `/drill/report/${this.state.drillReport.id}/answer/${idAnswerAttachment}/attachment/${encodeURIComponent(fileA.fileIdentifier)}` //RITM1094125
        )
      ).data;
      this.downloadFile(file, fileA.name, fileA.contentType);
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.FileUpload, apioperation.GET));
    } finally {
      this.setState({ downloading: null });
    }
    return file;
  };

  async uploadAnswerAttachment(idAnswerAttachment, newAttach) {
    const answer = this.state.drillReport.drillCheckListRequirementAnswers.find(
      (item) => item.attachments.count !== 0 && item.id === idAnswerAttachment
    );
    const index = this.state.drillReport.drillCheckListRequirementAnswers.indexOf(answer);
    this.setState({ isSubmitted: true });
    await api
      .post(
        `/drill/report/${this.state.drillReport.id}/answer/${idAnswerAttachment}/attachment`,
        newAttach
      )
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.ATTACHMENT, apioperation.POST));

          answer.attachments.push(response.data);
          this.setState((prevState) => {
            const drillReport = { ...prevState.drillReport };
            drillReport.drillCheckListRequirementAnswers[index] = answer;
            DrillRepository.updateCachedDrill(drillReport);
            return { drillReport };
          });
        } else {
          showNotification.error();
        }
        this.setState({ isSubmitted: false });
      })
      .catch((error) => {
        this.setState({ isSubmitted: false });
        return showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ATTACHMENT, apioperation.POST)
        );
      });
  }

  requirementDelete = async (requirementToDelete) => {
    try {
      this.setState({ isSubmitted: true });
      await api.delete('drill/report/checklistquestion/', requirementToDelete);
      this.setState({ isSubmitted: false });
      //RITM1267587
      // const { drillCheckListRequirementAnswers } = this.state.drillReport;

      // const index = drillCheckListRequirementAnswers.findIndex(
      //   (qa) => qa.requirement?.id === requirementToDelete
      // );
      // drillCheckListRequirementAnswers.splice(index, 1);
      // this.setState((prevState) => {
      //   const drillReport = { ...prevState.drillReport };
      //   drillReport.drillCheckListRequirementAnswers = drillCheckListRequirementAnswers;
      //   return { drillReport };
      // });
      //End
      showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL_REQ, apioperation.DELETE));
    } catch (error) {
      this.setState({ isSubmitted: false });
      //showNotification.error(`${entitiesLabels.ERROR}`, getError(entitiesLabels.EMERGENCYDRILL_REQ, apioperation.DELETE)); //RITM1267587
      throw error;
    }
  };
  // ***************** REPORT SUMMARY ***************** END

  // oppure (key, val)
  updateDrillReport(drillReport) {
    this.setState({
      drillReport,
    });
  }

  // ***************** RENDER ***************** START
  renderLoadingModal = () => {
    const show = this.state.isSubmitted;
    return show && <Loading active withOverlay description="Saving..." />;
  };

  // getUrlBack = () => {
  //   if (this.state.isLoadingDrillReport === false) {
  //     return this.props.history.goBack();
  //   }
  // };
 
  renderTabs = () => (
    <>
      <PageBreadCrumb
        linkTo={`/drill/${this.state.drillReport?.drillPlan?.id}/reports`}
        linkText="Drill Report List"
        titleLeft="Drill Report"
        batchActions={this.getStatusActions(this.context.user)}
        showButtonHistory={this.showButtonHistory()}
        showButtonReopen={( this.state.drillReport && (this.state.xReasons.length > 0) 
          && ( this.state.drillReport.status.reportingName == 'Completed') 
          && (this.state.drillReport.idCompiler == this.context.user.id || this.context.user.roles.includes('Administrator')))
          ?this.showButtonReopen():null }//RITM1037347        
        titleCenter={
          this.state.drillReport && this.state.drillReport.drillReportCode
            ? `ID: ${this.state.drillReport.drillReportCode}`
            : ''
        }
        titleRight={this.state.drillReport && this.state.drillReport.status ? `drill${this.state.drillReport.status?.reportingName}` : null}
        // RITM0537654 onClick={this.getUrlBack}
        isDisabled={this.state.isLoadingDrillReport}
      />
      {this.renderLoadingModal()}
      <div className="mainContainer">
        <div className="bx--grid content full-width mainContainer ">
          <WFActionModal
            show={this.state.isApprovalModalOpen}
            title={`${this.state.approvalModalAction} Drill`}
            action={this.state.approvalModalAction}
            withApprover={this.state.withApprover}
            approver={this.state.approver}
            approverRole={this.state.approverRole}
            approverOptions={this.state.approvers}
            isLoadingOperation={this.state.isLoadingWFOperation}
            onApproverSelect={this.handleApproverSelect}
            isLoadingOptions={this.state.isLoadingApproverOptions}
            onCancel={this.handleCloseApprovalModal}
            onConfirm={this.handleConfirmApprovalModal}
            onApprovalNotesChange={this.handleApprovalNotesChange}
            approvalNotes={this.state.approvalNotes}
            approvalNotesRequired={this.state.approvalNotesRequired}
            validationMessages={this.state.approvalValidationMessages}
            user={this.context.user} //RITM1064131
          />
           {!this.state.isReasonModalOpen ? '' : this.divModalReopenReason()}      
        {this.state.isWarningReOpenModalOpen ? (
            <WarningModal
                message="Are you sure that you want to reopen the emDrill report?"
                onCancel={this.toggleWarningReOpenModal}
                onConfirm={this.handleConfirmReOpenSubmit}
            />
        ) : null}

          {this.state.drillReport && (
            <HistoryTable
              entityId={this.state.drillReport.id}
              isOpenModal={this.state.isHistoryModalOpen}
              onClose={() => this.closeModalHistory()}
             masked={this.state.drillReport.drillPlan?.maskedValue} //RITM0946012 - Anonimizzazione Modulo Emergency Drill
            />
          )}
          {this.state.drillReport && (
          <div className="bx--row">
            <div className="bx--col detail--information drill">
              <DrillReportInformation
                is4ASingleReport
                tabsLoading={this.state.tabsLoading}
                drillReport={this.state.drillReport}
                isSendedNotification={this.state.drillReport?.drillNotificationForm?.sendedOn 
                  != null}
                disabled={this.state.editingDisabled}
              />
              {this.state.validationDeliveryDate ? (
                <div className="srv-validation-message">
                  {' '}
                  Enter the startDate and endDate in the main information
                </div>
              ) : (
                ''
              )}
            </div>
          </div>)}
          <div className="bx--row">
            {this.state.tabsLoading ? (
              <div className="bx--col-lg-12 bx--tab-container">
                <TabsSkeleton className="auditReportTab" />
              </div>
            ) : (
              <Tabs
                ariaLabel="listbox"
                className="auditReportTab"
                iconDescription="show menu options"
                onKeyDown={() => {}}
                role="navigation"
                selected={0}
                tabContentClassName="auditReportTab"
                triggerHref="#"
                type="default"
              >
                <Tab
                  href="#"
                  label="Notification Form"
                  onClick={() => {}}
                  onKeyDown={() => {}}
                  role="presentation"
                  work
                  selected={false}
                  tabIndex={0}
                >
                  <DrillNotificationForm
                    id="notificationForm"
                    NotificationFormData={this.state.drillReport.drillNotificationForm}
                    onSave={this.updateNotificationData}
                    onSend={this.sendNotificationData}
                    editingDisabled={this.state.editingDisabled}
                    drillReport={this.state.drillReport}
                  />
                </Tab>
                <Tab
                  href="#"
                  label="Report Detail"
                  onClick={() => {}}
                  onKeyDown={() => {}}
                  role="presentation"
                  selected={false}
                  tabIndex={0}
                  disabled={!this.state.drillReport?.drillNotificationForm?.sendedOn}
                >
                  <DrillReportDetail
                    drillReport={this.state.drillReport}
                    updateReportDetail={this.updateReportDetail}
                    downloadAttachment={this.downloadAttachment}
                    deleteAttachment={this.deleteAttachment}
                    onUpload={this.onUploadAttachment}
                    editingDisabled={this.state.editingDisabled}
                    downloading={this.state.downloading}
                    lightCondition={this.state.lightCondition}
                    seaCondition={this.state.seaCondition}
                    weatherCondition={this.state.weatherCondition}
                    emergencylevel={this.state.emergencylevel}
                    unitsInvolved={this.state.unitsInvolved}
                  />
                </Tab>

                <Tab
                  href="#"
                  label="Personnel"
                  onClick={() => {}}
                  onKeyDown={() => {}}
                  role="presentation"
                  selected={false}
                  tabIndex={0}
                  disabled={!this.state.drillReport?.drillNotificationForm?.sendedOn}
                >
                  <DrillPersonnel
                    drillReport={this.state.drillReport}
                    editingDisabled={this.state.editingDisabled}
                    onSave={this.updatePersonnel}
                  />
                </Tab>
                <Tab
                  href="#"
                  label="Report Summary"
                  // onClick={() => this.showRequirment()}
                  onKeyDown={() => {}}
                  role="presentation"
                  selected={false}
                  tabIndex={0}
                  disabled={!this.state.drillReport?.drillNotificationForm?.sendedOn}
                >
                  <DrillReportSummary
                    drillReport={this.state.drillReport}
                    editingDisabled={this.state.editingDisabled}
                    requirementDelete={this.requirementDelete}
                    downloadAnswerAttachment={this.downloadAnswerAttachment}
                    deleteAnswerAttachment={this.deleteAnswerAttachment}
                    uploadAnswerAttachment={this.uploadAnswerAttachment}
                    updateAnswers={this.updateAnswers}
                  />
                </Tab>
                <Tab
                  href="#"
                  label="CARs List"
                  onClick={() => {
                    this.props.history.push(`/drill/report/${this.props.match.params.id}/car`);
                  }}
                  selected={false}
                  tabIndex={0}
                  disabled={!this.state.drillReport?.drillNotificationForm?.sendedOn}
                />
                <Tab
                  href="#"
                  label="Drill Report Signed"
                  onKeyDown={() => {}}
                  role="presentation"
                  selected={false}
                  tabIndex={0}
                  disabled={!this.state.drillReport?.drillNotificationForm?.sendedOn}
                >
                  <DrillReportSignedAttachment
                    onUpload={this.onUploadSignedAttachment}
                    deleteSignedAttachment={this.deleteSignedAttachment}
                    drillReportId={this.state.drillReport?.id}
                    editingDisabled={this.state.editingDisabled}
                    signedAttachmentsArray={this.state.drillReport?.signedAttachments || []}
                  />
                </Tab>
              </Tabs>
            )}
          </div>
        </div>
      </div>
    </>
  );

  render() {
    return this.state.drillReport ? (
      <AppContext.Consumer>
        {({ user }) => (IsEnabled(user, 'Emergency Drill') ? 
          <>
            {this.renderTabs()}
            ;
          </> : '')}
      </AppContext.Consumer>
    ) : (
      <></>
    );
  }
  // ***************** RENDER ***************** END
}

DrillReport.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
    url: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    block: PropTypes.func,
    createHref: PropTypes.func,
    go: PropTypes.func,
    goBack: PropTypes.func,
    goForward: PropTypes.func,
    listen: PropTypes.func,
    push: PropTypes.func,
    replace: PropTypes.func,
    length: PropTypes.number,
    action: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      hash: PropTypes.string,
      key: PropTypes.string
    }),
  }).isRequired,
};

DrillReport.contextType = AppContext;
export default DrillReport;
